<mat-form-field floatLabel="always">
    <mat-label>{{lable}} </mat-label>
    <input
      type="text"
      placeholder=""
      matInput
      [formControl]="timeControl"
      [matAutocomplete]="auto"
      [(ngModel)]="inputselectedTime"
    />
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectTime($event.option.viewValue)">
      <mat-option *ngFor="let time of filteredTimeSlots | async" [value]="time">
        {{ time }}
      </mat-option>
    </mat-autocomplete>
    <button mat-button *ngIf="timeControl.value" matSuffix mat-icon-button (click)="clearInput()">
        <mat-icon>X</mat-icon>
      </button>
      <mat-error *ngIf="timeControl.hasError('required')">{{lable}} is Required</mat-error>
  </mat-form-field>